import { GET_USER_BRANDS } from '../constants/brands';

export default (state = [], action) => {
  const { type, payload = [] } = action;
  switch (type) {
    case GET_USER_BRANDS:
      if (payload) {
        return [...state, ...payload];
      }
      return state;
    default:
      return state;
  }
};
